
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("kGZ60", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0f9811f608c76b6b$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $aX1RZ = parcelRequire("aX1RZ");

var $5eamx = parcelRequire("5eamx");

var $lHKVC = parcelRequire("lHKVC");

var $2mLQs = parcelRequire("2mLQs");

var $hJmnk = parcelRequire("hJmnk");
// Snow
let $0f9811f608c76b6b$var$Snow = null;
const $0f9811f608c76b6b$var$LayoutAsync = ({ currentUser: currentUser })=>{
    (0, $aX1RZ.useEffect)(()=>{
        const evt = setInterval(async ()=>{
            // Sleepless night badge
            if (new Date().getHours() === 4) (0, $lHKVC.obtainBadge)("ec033641-9d14-4e95-b623-4698b31f19a9");
        }, 15000);
        return ()=>clearInterval(evt);
    }, []);
    (0, $aX1RZ.useEffect)(()=>{
        if (new Date().getMonth() === 11 || new Date().getDate() <= 6 && new Date().getMonth() === 0) {
            if (document.querySelector("header")) {
                if (!$0f9811f608c76b6b$var$Snow) $0f9811f608c76b6b$var$Snow = new (0, $2mLQs.default)(document.querySelector("header"));
                $0f9811f608c76b6b$var$Snow.start();
            }
        }
    }, []);
    return /*#__PURE__*/ (0, $1dxTK.jsxs)((0, $1dxTK.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1dxTK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5eamx))), {
                action: ()=>(0, $lHKVC.obtainBadge)("bbf75c71-8c09-4988-ab78-34068c97c474")
            }),
            currentUser?.me && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $hJmnk.default), {})
        ]
    });
};
var $0f9811f608c76b6b$export$2e2bcd8739ae039 = $0f9811f608c76b6b$var$LayoutAsync;

});
parcelRegister("5eamx", function(module, exports) {


(()=>{
    "use strict";
    var t = {
        n: (e)=>{
            var n = e && e.__esModule ? ()=>e.default : ()=>e;
            return t.d(n, {
                a: n
            }), n;
        },
        d: (e, n)=>{
            for(var o in n)t.o(n, o) && !t.o(e, o) && Object.defineProperty(e, o, {
                enumerable: !0,
                get: n[o]
            });
        },
        o: (t, e)=>Object.prototype.hasOwnProperty.call(t, e),
        r: (t)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }
    }, e = {};
    t.r(e), t.d(e, {
        default: ()=>f,
        useKonami: ()=>h
    });
    const n = (parcelRequire("aX1RZ"));
    var o = t.n(n);
    const r = (parcelRequire("bSCfU"));
    var i = t.n(r);
    const s = function() {
        function t(t, e) {
            this.t = e, this.fn = t, this.timerIntervalID = setInterval(this.fn, this.t);
        }
        return t.prototype.stop = function() {
            return this.timerIntervalID && (clearInterval(this.timerIntervalID), this.timerIntervalID = null), this;
        }, t.prototype.start = function() {
            return this.timerIntervalID || (this.stop(), this.timerIntervalID = setInterval(this.fn, this.t)), this;
        }, t.prototype.reset = function(t) {
            return this.t = t, this.stop().start();
        }, t;
    }(), u = function(t, e) {
        return !(!Array.isArray(t) || !Array.isArray(e)) && t.length === e.length && t.every(function(t, n) {
            return t === e[n];
        });
    };
    var a, p = [
        38,
        38,
        40,
        40,
        37,
        39,
        37,
        39,
        66,
        65
    ], l = (a = function(t, e) {
        return a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }, a(t, e);
    }, function(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        function n() {
            this.constructor = t;
        }
        a(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
    }), c = {
        action: i().func,
        className: i().string,
        code: i().arrayOf(i().number),
        disabled: i().bool,
        onTimeout: i().func,
        resetDelay: i().number,
        timeout: i().number
    }, d = function(t) {
        function e(e) {
            var n = t.call(this, e) || this;
            return n.state = {
                done: !1,
                input: []
            }, n.timeoutID = null, n.onKeyUp = n.onKeyUp.bind(n), n.resetInput = n.resetInput.bind(n), n;
        }
        return l(e, t), e.prototype.componentDidMount = function() {
            var t = this, e = this.props.resetDelay;
            document.addEventListener("keyup", this.onKeyUp);
            var n = Number(e);
            0 !== n && (this._timer = new s(function() {
                return t.resetInput();
            }, n));
        }, e.prototype.shouldComponentUpdate = function(t, e) {
            return this.props.className !== t.className || this.props.disabled !== t.disabled || this.state.done !== e.done;
        }, e.prototype.componentWillUnmount = function() {
            var t = this.props.resetDelay;
            this.timeoutID && clearTimeout(this.timeoutID), 0 !== t && this._timer.stop(), document.removeEventListener("keyup", this.onKeyUp);
        }, e.prototype.onKeyUp = function(t) {
            var e = this, n = this.state, o = n.done, r = n.input, i = this.props, s = i.action, a = i.code, p = i.disabled, l = i.onTimeout, c = i.resetDelay, d = i.timeout, h = Number(c);
            p || (0 !== h && this._timer.reset(h), r.push(t.keyCode), a && r.splice(-a.length - 1, r.length - a.length), this.setState({
                input: r
            }, function() {
                u(e.state.input, a) && !o && (0 !== h && e._timer.stop(), e.setState({
                    done: !0
                }, function() {
                    "function" == typeof s && s();
                }), d && (e.timeoutID = setTimeout(function() {
                    e.setState({
                        done: !1
                    }), "function" == typeof l && l();
                }, Number(d))));
            }));
        }, e.prototype.resetInput = function() {
            this.setState({
                input: []
            });
        }, e.prototype.render = function() {
            var t = this.props, e = t.children, n = t.className, r = t.disabled, i = this.state.done;
            return o().createElement("div", {
                className: "konami ".concat(null != n ? n : ""),
                style: {
                    display: !i || r ? "none" : "block"
                }
            }, e);
        }, e;
    }(o().Component);
    d.defaultProps = {
        className: "",
        code: p,
        disabled: !1,
        resetDelay: 1e3,
        children: null,
        action: null,
        onTimeout: null,
        timeout: 0
    }, d.propTypes = c;
    const h = function(t, e) {
        var o = (void 0 === e ? {} : e).code, r = void 0 === o ? p : o, i = (0, n.useState)([]), s = i[0], u = i[1], a = (0, n.useCallback)(function(e) {
            var n = s;
            n.push(e.keyCode), n.splice(-r.length - 1, s.length - r.length), u(n), n.join("").includes(r.join("")) && t();
        }, [
            s,
            u,
            r,
            t
        ]);
        (0, n.useEffect)(function() {
            return document.addEventListener("keyup", a), function() {
                document.removeEventListener("keyup", a);
            };
        }, [
            a
        ]);
    }, f = d;
    module.exports = e;
})();

});

parcelRegister("2mLQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b92bfdbeb04fc26$export$2e2bcd8739ae039; });
// Based on Zds source code
// Changes: Add STOP value to stop snow
class $1b92bfdbeb04fc26$var$LetItSnow {
    PARTICLES_COLOR = "rgba(255, 255, 255, 0.3)";
    MAX_PARTICLES = 35;
    SPAWN_RATE = 100;
    PARTICLES_SPEED = 16;
    PARTICLES_SIZE = 2;
    TURBULENCES_X = 1;
    TURBULENCES_Y = 0.5;
    TURBULENCES_SPEED = 1;
    MAX_TIMESHIFT = Math.PI / 3;
    STOP = true;
    constructor(element){
        this._parent = element;
        // Init canvas
        this._canvas = document.createElement("canvas");
        this._canvas.style.position = "absolute";
        this._canvas.style.zIndex = -2;
        this._canvas.style.margin = "auto";
        this._canvas.style.marginTop = "0px";
        this._canvas.style.pointerEvents = "none";
        this._canvas.style.top = 0;
        this._canvas.style.left = 0;
        this._canvas.style.right = 0;
        this._canvas.style.bottom = 0;
        this._ctx = this._canvas.getContext("2d");
        // Set spawn time
        this._lastSpawn = this._lastLoop = Date.now();
        // Update canvas size to parent
        this.updateCanvasSize();
        // Append the canvas...
        this._parent.appendChild(this._canvas);
        // No particles by default
        this.particles = [];
        window.addEventListener("resize", this.updateCanvasSize.bind(this));
    }
    stop() {
        this.STOP = true;
    }
    start() {
        const previousValue = this.STOP;
        this.STOP = false;
        if (previousValue === true) this.loop();
    }
    updateCanvasSize() {
        const rect = this._parent.getBoundingClientRect();
        this.H = rect.height;
        this.W = rect.width;
        this._canvas.height = this.H;
        this._canvas.width = this.W;
    }
    spawnParticle() {
        this.particles.push({
            x: Math.random() * this.W,
            y: -this.PARTICLES_SIZE,
            d: Math.random() + 1,
            s: Math.random() * this.MAX_TIMESHIFT // Time shift
        });
    }
    loop() {
        if (this.STOP) this._ctx.clearRect(0, 0, this.W, this.H);
        else {
            this.update();
            this.draw();
            requestAnimationFrame(this.loop.bind(this));
        }
    }
    update() {
        const now = Date.now();
        const delta = now - this._lastLoop;
        for(let i in this.particles){
            let p = this.particles[i];
            p.y += delta / 1000 * (this.PARTICLES_SPEED * p.d * (1.5 + Math.sin(now * this.TURBULENCES_SPEED / 1000 + p.s) * this.TURBULENCES_Y));
            p.x += delta / 1000 * (this.PARTICLES_SPEED * p.d * (Math.cos(now * this.TURBULENCES_SPEED / 1000 + p.s) * this.TURBULENCES_X));
            if (p.y - p.d * 4 > this.H || p.x - p.d * 4 > this.W || p.x + p.d * 4 < 0) this.particles.splice(i, 1);
        }
        if (this._lastSpawn <= now - this.SPAWN_RATE && this.particles.length < this.MAX_PARTICLES) {
            this._lastSpawn = now;
            this.spawnParticle();
        }
        this._lastLoop = now;
    }
    draw() {
        this._ctx.clearRect(0, 0, this.W, this.H);
        this._ctx.fillStyle = this.PARTICLES_COLOR;
        this._ctx.beginPath();
        for (const p of this.particles){
            this._ctx.moveTo(p.x, p.y);
            this._ctx.arc(p.x, p.y, p.d * this.PARTICLES_SIZE, 0, Math.PI * 2, true);
        }
        this._ctx.fill();
    }
}
var $1b92bfdbeb04fc26$export$2e2bcd8739ae039 = $1b92bfdbeb04fc26$var$LetItSnow;

});

parcelRegister("hJmnk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $766b7a3c0e381f2a$export$2e2bcd8739ae039; });

var $aX1RZ = parcelRequire("aX1RZ");

var $lHKVC = parcelRequire("lHKVC");

var $kWjpS = parcelRequire("kWjpS");

var $avmr1 = parcelRequire("avmr1");
let $766b7a3c0e381f2a$var$joke = Math.floor(Math.random() * Object.keys($avmr1).filter((name)=>/^joke-/.test(name)).length) + 1;
const $766b7a3c0e381f2a$var$isAprilFoolDay = ()=>{
    const now = new Date();
    return now.getDate() === 1 && now.getMonth() === 3;
};
const $766b7a3c0e381f2a$var$Fun = ()=>{
    (0, $aX1RZ.useEffect)(()=>{
        const evt = setInterval(async ()=>{
            // April fools
            if ($766b7a3c0e381f2a$var$isAprilFoolDay()) (0, $lHKVC.obtainBadge)("a917d55b-46b3-4065-9b75-4f8ce7c02b8a");
        }, 15000);
        return ()=>clearInterval(evt);
    }, []);
    // Not april fool day
    if (!$766b7a3c0e381f2a$var$isAprilFoolDay()) return null;
    // April fools is disabled manually
    if (!localStorage.getItem((0, $kWjpS.LS_APRIL_FOOL))) // Class not already set
    {
        if (![
            ...document.documentElement.classList
        ].some((cn)=>cn === $avmr1[`joke-${$766b7a3c0e381f2a$var$joke}`])) {
            console.log(`\u{1F3A3} Joke #${$766b7a3c0e381f2a$var$joke}`);
            // Remove all joke classes
            document.documentElement.classList.forEach((e)=>{
                for (const className of Object.keys($avmr1))if (e === $avmr1[className]) {
                    document.documentElement.classList.remove(e);
                    break;
                }
            });
            // Set joke class
            document.documentElement.classList.add($avmr1[`joke-${$766b7a3c0e381f2a$var$joke}`]);
        }
    } else console.log("\uD83C\uDF63 No fun allowed");
    return null;
};
var $766b7a3c0e381f2a$export$2e2bcd8739ae039 = $766b7a3c0e381f2a$var$Fun;

});
parcelRegister("avmr1", function(module, exports) {

$parcel$export(module.exports, "joke-1", function () { return $7a5e33be8e57bd98$export$e271fd248cb9bb72; }, function (v) { return $7a5e33be8e57bd98$export$e271fd248cb9bb72 = v; });
$parcel$export(module.exports, "joke-10", function () { return $7a5e33be8e57bd98$export$71a5df0ab38ba9b8; }, function (v) { return $7a5e33be8e57bd98$export$71a5df0ab38ba9b8 = v; });
$parcel$export(module.exports, "joke-11", function () { return $7a5e33be8e57bd98$export$76bc582ef132f869; }, function (v) { return $7a5e33be8e57bd98$export$76bc582ef132f869 = v; });
$parcel$export(module.exports, "joke-12", function () { return $7a5e33be8e57bd98$export$918701f4308ff699; }, function (v) { return $7a5e33be8e57bd98$export$918701f4308ff699 = v; });
$parcel$export(module.exports, "joke-13", function () { return $7a5e33be8e57bd98$export$5a380f7d64ef42d1; }, function (v) { return $7a5e33be8e57bd98$export$5a380f7d64ef42d1 = v; });
$parcel$export(module.exports, "joke-14", function () { return $7a5e33be8e57bd98$export$5f07eeb2a5be4abc; }, function (v) { return $7a5e33be8e57bd98$export$5f07eeb2a5be4abc = v; });
$parcel$export(module.exports, "joke-15", function () { return $7a5e33be8e57bd98$export$3339e5570703c4a0; }, function (v) { return $7a5e33be8e57bd98$export$3339e5570703c4a0 = v; });
$parcel$export(module.exports, "joke-16", function () { return $7a5e33be8e57bd98$export$ae96fa6ee9f40e12; }, function (v) { return $7a5e33be8e57bd98$export$ae96fa6ee9f40e12 = v; });
$parcel$export(module.exports, "joke-17", function () { return $7a5e33be8e57bd98$export$7917ae871b384d1d; }, function (v) { return $7a5e33be8e57bd98$export$7917ae871b384d1d = v; });
$parcel$export(module.exports, "joke-2", function () { return $7a5e33be8e57bd98$export$97d0cd2c62f3b84b; }, function (v) { return $7a5e33be8e57bd98$export$97d0cd2c62f3b84b = v; });
$parcel$export(module.exports, "joke-3", function () { return $7a5e33be8e57bd98$export$f0a8017cfd30a8b0; }, function (v) { return $7a5e33be8e57bd98$export$f0a8017cfd30a8b0 = v; });
$parcel$export(module.exports, "joke-4", function () { return $7a5e33be8e57bd98$export$336e31e557741d37; }, function (v) { return $7a5e33be8e57bd98$export$336e31e557741d37 = v; });
$parcel$export(module.exports, "joke-5", function () { return $7a5e33be8e57bd98$export$3bc8487cef76aef5; }, function (v) { return $7a5e33be8e57bd98$export$3bc8487cef76aef5 = v; });
$parcel$export(module.exports, "joke-6", function () { return $7a5e33be8e57bd98$export$8aced8dd20d8f7de; }, function (v) { return $7a5e33be8e57bd98$export$8aced8dd20d8f7de = v; });
$parcel$export(module.exports, "joke-7", function () { return $7a5e33be8e57bd98$export$fc96f876bc0ffea7; }, function (v) { return $7a5e33be8e57bd98$export$fc96f876bc0ffea7 = v; });
$parcel$export(module.exports, "joke-8", function () { return $7a5e33be8e57bd98$export$58c7614d033fb419; }, function (v) { return $7a5e33be8e57bd98$export$58c7614d033fb419 = v; });
$parcel$export(module.exports, "joke-9", function () { return $7a5e33be8e57bd98$export$e23ca149e5c558f0; }, function (v) { return $7a5e33be8e57bd98$export$e23ca149e5c558f0 = v; });
$parcel$export(module.exports, "joke10", function () { return $7a5e33be8e57bd98$export$8dfbd01fc9b1f27d; }, function (v) { return $7a5e33be8e57bd98$export$8dfbd01fc9b1f27d = v; });
$parcel$export(module.exports, "joke2", function () { return $7a5e33be8e57bd98$export$dbf31142be91d870; }, function (v) { return $7a5e33be8e57bd98$export$dbf31142be91d870 = v; });
$parcel$export(module.exports, "joke3", function () { return $7a5e33be8e57bd98$export$38014a10dd9b0634; }, function (v) { return $7a5e33be8e57bd98$export$38014a10dd9b0634 = v; });
$parcel$export(module.exports, "joke5", function () { return $7a5e33be8e57bd98$export$5d57488d93b7849f; }, function (v) { return $7a5e33be8e57bd98$export$5d57488d93b7849f = v; });
$parcel$export(module.exports, "joke6", function () { return $7a5e33be8e57bd98$export$70fc33e072c82e32; }, function (v) { return $7a5e33be8e57bd98$export$70fc33e072c82e32 = v; });
var $7a5e33be8e57bd98$export$e271fd248cb9bb72;
var $7a5e33be8e57bd98$export$71a5df0ab38ba9b8;
var $7a5e33be8e57bd98$export$76bc582ef132f869;
var $7a5e33be8e57bd98$export$918701f4308ff699;
var $7a5e33be8e57bd98$export$5a380f7d64ef42d1;
var $7a5e33be8e57bd98$export$5f07eeb2a5be4abc;
var $7a5e33be8e57bd98$export$3339e5570703c4a0;
var $7a5e33be8e57bd98$export$ae96fa6ee9f40e12;
var $7a5e33be8e57bd98$export$7917ae871b384d1d;
var $7a5e33be8e57bd98$export$97d0cd2c62f3b84b;
var $7a5e33be8e57bd98$export$f0a8017cfd30a8b0;
var $7a5e33be8e57bd98$export$336e31e557741d37;
var $7a5e33be8e57bd98$export$3bc8487cef76aef5;
var $7a5e33be8e57bd98$export$8aced8dd20d8f7de;
var $7a5e33be8e57bd98$export$fc96f876bc0ffea7;
var $7a5e33be8e57bd98$export$58c7614d033fb419;
var $7a5e33be8e57bd98$export$e23ca149e5c558f0;
var $7a5e33be8e57bd98$export$8dfbd01fc9b1f27d;
var $7a5e33be8e57bd98$export$dbf31142be91d870;
var $7a5e33be8e57bd98$export$38014a10dd9b0634;
var $7a5e33be8e57bd98$export$5d57488d93b7849f;
var $7a5e33be8e57bd98$export$70fc33e072c82e32;
$7a5e33be8e57bd98$export$e271fd248cb9bb72 = `j5ZNeW_joke-1`;
$7a5e33be8e57bd98$export$71a5df0ab38ba9b8 = `j5ZNeW_joke-10`;
$7a5e33be8e57bd98$export$76bc582ef132f869 = `j5ZNeW_joke-11`;
$7a5e33be8e57bd98$export$918701f4308ff699 = `j5ZNeW_joke-12`;
$7a5e33be8e57bd98$export$5a380f7d64ef42d1 = `j5ZNeW_joke-13`;
$7a5e33be8e57bd98$export$5f07eeb2a5be4abc = `j5ZNeW_joke-14`;
$7a5e33be8e57bd98$export$3339e5570703c4a0 = `j5ZNeW_joke-15`;
$7a5e33be8e57bd98$export$ae96fa6ee9f40e12 = `j5ZNeW_joke-16`;
$7a5e33be8e57bd98$export$7917ae871b384d1d = `j5ZNeW_joke-17`;
$7a5e33be8e57bd98$export$97d0cd2c62f3b84b = `j5ZNeW_joke-2`;
$7a5e33be8e57bd98$export$f0a8017cfd30a8b0 = `j5ZNeW_joke-3`;
$7a5e33be8e57bd98$export$336e31e557741d37 = `j5ZNeW_joke-4`;
$7a5e33be8e57bd98$export$3bc8487cef76aef5 = `j5ZNeW_joke-5`;
$7a5e33be8e57bd98$export$8aced8dd20d8f7de = `j5ZNeW_joke-6`;
$7a5e33be8e57bd98$export$fc96f876bc0ffea7 = `j5ZNeW_joke-7`;
$7a5e33be8e57bd98$export$58c7614d033fb419 = `j5ZNeW_joke-8`;
$7a5e33be8e57bd98$export$e23ca149e5c558f0 = `j5ZNeW_joke-9`;
$7a5e33be8e57bd98$export$8dfbd01fc9b1f27d = `j5ZNeW_joke10`;
$7a5e33be8e57bd98$export$8dfbd01fc9b1f27d;
$7a5e33be8e57bd98$export$dbf31142be91d870 = `j5ZNeW_joke2`;
$7a5e33be8e57bd98$export$dbf31142be91d870;
$7a5e33be8e57bd98$export$38014a10dd9b0634 = `j5ZNeW_joke3`;
$7a5e33be8e57bd98$export$38014a10dd9b0634;
$7a5e33be8e57bd98$export$5d57488d93b7849f = `j5ZNeW_joke5`;
$7a5e33be8e57bd98$export$5d57488d93b7849f;
$7a5e33be8e57bd98$export$70fc33e072c82e32 = `j5ZNeW_joke6`;
$7a5e33be8e57bd98$export$70fc33e072c82e32;

});




//# sourceMappingURL=LayoutAsync.176199f0.js.map
